import React from 'react';
import './App.css';
import RentalApp from './components/RentalApp';

function App() {
  return (
    <RentalApp></RentalApp>
  );
}

export default App;
